import { useState, useEffect } from 'react';
import http from 'hub-http/clients/apiClient';
import useUserInfo from './useUserInfo';
import { MULTI_CURRENCY_MIGRATION_GATE, MULTI_CURRENCY_V1_ENDPOINT, MULTI_CURRENCY_V2_ENDPOINT } from '../constants/multiCurrencyConstants';
export default function useCurrencySelectInfo({
  skip
} = {}) {
  const [currencySelectInfo, setCurrencySelectInfo] = useState({});
  const {
    isUngatedFor
  } = useUserInfo();
  useEffect(() => {
    if (!skip) {
      // Use v2 API if ungated, otherwise use v1 API
      const endpoint = isUngatedFor(MULTI_CURRENCY_MIGRATION_GATE) ? MULTI_CURRENCY_V2_ENDPOINT : MULTI_CURRENCY_V1_ENDPOINT;
      http.get(endpoint).then(({
        currencyExchangeRates,
        homeCurrency
      }) => {
        const homeCurrencyCode = homeCurrency && homeCurrency.currencyCode;
        const validCurrencies = [...new Set(currencyExchangeRates.filter(xr => xr.visible).map(xr => xr.fromCurrencyCode).concat(homeCurrencyCode || []))];
        const currenciesFilter = ({
          value
        }) => validCurrencies.includes(value);
        setCurrencySelectInfo({
          currenciesFilter,
          homeCurrencyCode
        });
      }).catch(() => {});
    }
  }, [skip, isUngatedFor]);
  return currencySelectInfo;
}